import { apiUrlAllProducts, apiUrlGetProduct, apiUrlSearchedProducts } from '@lib/core/products/slices/urls';
import { IApiUrlGetProductProps, TProductInstance } from '@lib/core/products/types';
import { ApiQueries } from '@lib/core/service/consts';
import { request } from '@lib/core/service/requests/request';
import { selectServiceProductCategory } from '@lib/core/service/selectors';
import { store } from '@lib/core/service/store';
import { IProductsResponse } from '@lib/core/service/types/interface';
import { productsSuggestionApiUrlCreator } from '@lib/core/users/slices/urls';

export interface IRequestParams {
  offset?: number;
  limit?: number;
  [ApiQueries.character]?: string;
  [ApiQueries.productCategory]?: string;
  [ApiQueries.promotions]?: string;
  [ApiQueries.preferences]?: string;
  [ApiQueries.ordering]?: string;
  [ApiQueries.associatedRetailerSlug]?: string;
}

const getProductData = ({
  productId,
  customRetailerSlug,
  customRetailerLocationSlug,
}: IApiUrlGetProductProps): Promise<TProductInstance> => {
  const requestUrl = apiUrlGetProduct({ customRetailerLocationSlug, customRetailerSlug, productId });

  return request({
    additionalHeaders: {
      Accept: 'application/json; version="2.0"',
    },
    url: requestUrl,
  });
};

// extended
const getProductsListData = (params: IRequestParams): Promise<IProductsResponse> => {
  const paramsToBeSent = { ...params };
  if (paramsToBeSent[ApiQueries.character]) {
    paramsToBeSent[ApiQueries.character].split('-').join(',');
  }
  const requestUrl = paramsToBeSent[ApiQueries.productName] ? apiUrlSearchedProducts() : apiUrlAllProducts();
  return request({
    additionalHeaders: {
      Accept: 'application/json; version="2.0"',
    },
    params: paramsToBeSent,
    url: requestUrl,
  });
};

const getTastePathProductsData = (params: Record<string, string | number>) => {
  const state = store.getState();
  const productCategory = selectServiceProductCategory(state);

  const requestUrl = productsSuggestionApiUrlCreator({ productCategory });

  return request({
    params,
    url: requestUrl,
  });
};

export { getProductData, getProductsListData, getTastePathProductsData };
